import type { Cart_jsonld_read, Cart_jsonld_write } from '@/features/cart/cart-post-type';

import { isSameDate } from '@/core/features/date/date';
import { clientSideApiPostRequest } from '@/core/features/request/client-side-request';

type CartItemDiscriminator = {
    endDate: Date;
    offerId: string;
    startDate: Date;
};

export async function postCartClientSide(request: Cart_jsonld_write): Promise<Cart_jsonld_read> {
    const response = await clientSideApiPostRequest<Cart_jsonld_read>('/booking/cart', request);

    return response.data;
}

export function isSameItem(item1: CartItemDiscriminator, item2: CartItemDiscriminator): boolean {
    return (
        item1.offerId === item2.offerId &&
        isSameDate(item1.startDate, item2.startDate) &&
        isSameDate(item1.endDate, item2.endDate)
    );
}
